<script lang="ts" setup>
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { type IInfoBlock } from '@/utils/types'

const props = defineProps({
  data: {
    type: Array as PropType<Array<IInfoBlock>>,
    default: []
  },
  title: {
    type: String,
    default: ''
  },
  description: {
    type: String,
    default: ''
  }

})
gsap.registerPlugin(ScrollTrigger)

const refSection1Title = ref()
const section1TitleWidth = ref(0)

const currentIndex = ref(0)

const section1TextShow = ref(true)
const slideNumberShow = ref(true)

const refSection1 = ref()
const refSection2 = ref()

const handleScroll = () => {
  let top1 = parseInt(refSection1.value.getBoundingClientRect().top)
  let top2 = parseInt(refSection2.value.getBoundingClientRect().top)
  if (top1 >= 0) {
    currentIndex.value = 0
    if (top1 === 0) {
      section1TextShow.value = false
    } else {
      section1TextShow.value = true
    }
  } else if (top1 < 0) {
    currentIndex.value = 1
    if (top1 < 0 && top2 < 0) {
      currentIndex.value = 2
    }
  }
}

const initAni = () => {
  const gTimeLine = gsap.timeline()
  // if (window.innerWidth > 990) {
  gTimeLine
    .fromTo(
      '.section1__pic',
      {
        width: '47%',
        height: '70%',
        // paddingTop: '47%',
        borderRadius: '3000px 3000px 0 0'
      },
      {
        width: '100%',
        height: '100vh',
        // paddingTop: '100%',
        borderRadius: '0 0 0 0',
        scrollTrigger: {
          trigger: '.section1',
          start: 'top',
          end: 'bottom',
          scrub: true,
          pin: true
        }
      }
    )
    .fromTo(
      '.section1__titlePic',
      {
        width: '39%',
        top: '26%'
      },
      {
        width: '100%',
        top: '88px',
        scrollTrigger: {
          trigger: '.section1',
          start: 'top',
          end: 'bottom',
          scrub: true
        }
      }
    )
    .to('.section2__pic', {
      y: -200,
      scrollTrigger: {
        trigger: '.section2',
        // start: 'top',
        // end: 'bottom',
        scrub: true
      }
    })
  // } else {
  //   gTimeLine
  //     .fromTo(
  //       '.section1__pic',
  //       {
  //         width: '47%',
  //         // height: '47%',
  //         paddingTop: '47%',
  //         borderRadius: '3000px'
  //       },
  //       {
  //         width: '100%',
  //         height: '100vh',
  //         // paddingTop: '100%',
  //         borderRadius: '0 0 0 0',
  //         scrollTrigger: {
  //           trigger: '.section1',
  //           start: 'top',
  //           end: 'bottom',
  //           scrub: true,
  //           pin: true
  //         }
  //       }
  //     )
  //     .fromTo(
  //       '.section1__titlePic',
  //       {
  //         width: '39%',
  //         top: '26%'
  //       },
  //       {
  //         width: '100%',
  //         top: '88px',
  //         scrollTrigger: {
  //           trigger: '.section1',
  //           start: 'top',
  //           end: 'bottom',
  //           scrub: true
  //         }
  //       }
  //     )
  //     .to('.section2__pic', {
  //       y: -200,
  //       scrollTrigger: {
  //         trigger: '.section2',
  //         // start: 'top',
  //         // end: 'bottom',
  //         scrub: true
  //       }
  //     })
  // }

  if (window.innerWidth > 767) {
    gTimeLine.fromTo(
      '.section3__pic',
      {
        y: -200,
        width: '100%',
        height: '100vh'
      },
      {
        y: 200,
        width: '47%',
        height: '65%',
        scrollTrigger: {
          trigger: '.section3',
          start: 'top',
          end: 'bottom',
          scrub: true,
          pin: true,
          onLeave: () => {
            slideNumberShow.value = false
          },
          onEnterBack: () => {
            slideNumberShow.value = true
          }
        }
      }
    )
  } else {
    gTimeLine.fromTo(
      '.section3__pic',
      {
        y: -200,
        width: '100%',
        height: '100vh'
      },
      {
        y: 200,
        width: '55%',
        height: '28%',
        scrollTrigger: {
          trigger: '.section3',
          start: 'top',
          end: 'bottom',
          scrub: true,
          pin: true,
          onLeave: () => {
            slideNumberShow.value = false
          },
          onEnterBack: () => {
            slideNumberShow.value = true
          }
        }
      }
    )
  }
}

const isShowTitle: Ref<boolean> = ref(false)
const isShowTextNumber: Ref<boolean> = ref(false)
const isShowPic: Ref<boolean> = ref(false)

onMounted(() => {
  section1TitleWidth.value = refSection1Title.value.getBoundingClientRect()
  useImagesLoaded('.zonezoneBox1 img').then(initAni)
  window.addEventListener('scroll', handleScroll)
  setTimeout(() => {
    isShowTitle.value = true
  }, 500)
  setTimeout(() => {
    isShowTextNumber.value = true
  }, 1000)
  setTimeout(() => {
    isShowPic.value = true
  }, 1500)
})

onUnmounted(() => {
  window.removeEventListener('scroll', handleScroll)
})
</script>

<template>
  <section class="zonezoneBox1" ref="main">
    <transition>
      <div class="section__number" v-show="slideNumberShow">
        <div class="section__number__inner" :class="{ isShow: isShowTextNumber }">
          <div class="section__number__current">
            <div class="section__number__current__inner" :style="{ transform: `translateY(-${currentIndex * 90}px)` }">
              <div class="section__number__current__item">01</div>
              <div class="section__number__current__item">02</div>
              <div class="section__number__current__item">03</div>
            </div>
          </div>
          <div class="section__number__line"></div>
          <div class="section__number__total">03</div>
        </div>
      </div>
    </transition>
    <div class="section section1" ref="refSection1">
      <figure class="section1__titlePic" ref="refSection1Title">
        <div class="section1__titlePic__inner" :class="{ isShow: isShowTitle }">
          <Nimg src="./images/zonezone.svg" format="" />
        </div>
      </figure>
      <div class="section1__pic" :class="{ isShow: isShowPic }">
        <img :src="data[0]?.image_lg?.link" :alt="data[0]?.image_lg?.alt" :title="data[0]?.image_lg?.title" />
      </div>
      <transition>
        <div class="section1__textBox" :class="{ isShow: isShowTextNumber }" v-show="section1TextShow">
          <div class="section1__textBox__inner" v-html="description"></div>
        </div>
      </transition>
    </div>
    <div class="section section2" ref="refSection2">
      <div class="section2__pic">
        <img :src="data[1]?.image_lg?.link" :alt="data[1]?.image_lg?.alt" :title="data[2]?.image_lg?.title" />
      </div>
    </div>
    <div class="section section3">
      <div class="section3__pic">
        <img :src="data[2]?.image_lg?.link" :alt="data[2]?.image_lg?.alt" :title="data[3]?.image_lg?.title" />
      </div>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.zonezoneBox1 {
  margin-top: toRem(-140);

  @include max-media(640) {
    margin-left: toRem(-20);
    margin-right: toRem(-20);
  }
}

.section {
  width: 100%;
  height: 100vh;

  &__number {
    position: fixed;
    left: toRem(24);
    bottom: toRem(24);
    z-index: 2;

    @include max-media(990) {
      left: 0;
      width: 100%;
      justify-content: center;
      transform: scale(0.3);
      transform-origin: center bottom;
    }

    &__inner {
      display: flex;
      align-items: flex-end;
      font-size: 90px;
      z-index: 50;
      color: $color-white-1;
      font-family: $font-TextaAlt;
      line-height: 1;
      opacity: 0;
      transform: translateY(30px);
      transition: all 0.8s ease-in-out;

      @include max-media(990) {
        width: 100%;
        justify-content: center;
      }

      &.isShow {
        transform: translateY(0);
        opacity: 1;
      }
    }

    &__current,
    &__total {
      height: toRem(90);
    }

    &__current {
      position: relative;
      overflow: hidden;

      &__inner {
        transition: all 0.5s cubic-bezier(0.87, 0, 0.13, 1);
      }
    }

    &__line {
      width: toRem(1);
      height: toRem(122);
      margin-left: toRem(26);
      margin-right: toRem(14);
      background-color: $color-white-1;
      transform: rotate(15deg) translateY(-10px);
    }
  }
}

.section1 {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-end;

  &__titlePic {
    position: absolute;
    left: 50%;
    top: 26%;
    z-index: 1;
    transform: translateX(-50%);

    @include max-media(640) {
      width: 100% !important;
      left: 0;
      top: toRem(140);
      padding-left: toRem(20);
      padding-right: toRem(20);
      transform: translateX(0%);
    }

    &__inner {
      opacity: 0;
      transform: translateY(30px);
      transition: all 0.8s ease-in-out;

      &.isShow {
        opacity: 1;
        transform: translateY(0);
      }
    }

    img {
      display: block;
      width: 100%;
    }
  }

  &__pic {
    position: relative;
    width: 47%;
    // padding-top: 47%;
    overflow: hidden;

    @include max-media(990) {
      // position: absolute;
      // left: 50%;
      // top: 50%;
      // transform: translate(-50%, -50%);
      width: 100% !important;
    }

    &.isShow {
      img {
        border-radius: 0;
        transform: translate(-50%, -50%) scale(1);
      }
    }

    img {
      // @include imgCover;
      position: absolute;
      left: 50%;
      top: 50%;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 50%;
      transform: translate(-50%, -50%) scale(0);
      transform-origin: center;
      transition: all 0.8s ease-in-out;
    }
  }

  &__textBox {
    color: $color-white-1;

    @include min-media(991) {
      position: absolute;
      left: 50%;
      // top: 50%;
      bottom: -10%;
      transform: translateY(-50%);
      padding-left: 28%;
      padding-top: 10%;
    }

    @include max-media(990) {
      position: absolute;
      left: 0;
      bottom: toRem(90);
      width: 100%;
      // padding-top: toRem(50);
      // padding-bottom: toRem(130);
      padding-left: toRem(24);
      padding-right: toRem(24);
      text-align: center;
    }

    &__inner {
      opacity: 0;
      transform: translateY(30px);
      transition: all 0.8s ease-in-out;

      :deep(p:empty) {
        margin-top: 1em;
        margin-bottom: 1em;
        min-height: .1em;
      }
    }

    &.isShow {
      .section1 {
        &__textBox {
          &__inner {
            transform: translateY(0);
            opacity: 1;
          }
        }
      }
    }
  }

  &__title {
    font-size: toRem(16);
    font-weight: 700;
    margin-bottom: toRem(15);
  }

  &__text {
    font-size: toRem(14);
    font-weight: 400;
  }
}

.section2 {
  &__pic {
    width: 100%;
    height: 100vh;

    img {
      @include imgCover;
    }
  }
}

.section3 {
  display: flex;
  justify-content: center;

  &__pic {
    width: 100%;
    height: 100vh;

    img {
      @include imgCover;
    }
  }
}
</style>
